/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useEffect, useState} from 'react'
import DataTable from 'react-data-table-component'
import {Link} from 'react-router-dom'
import axios from 'axios'
import {useParams} from 'react-router-dom'
import Swal from 'sweetalert2'
import {Modal} from 'react-bootstrap'
import firebase from '../../../../firebase/FirebaseConfig'
import apiConnect from '../../../../api/apiConnect'

const EditParameterModal = ({
  showModalEditParameter,
  setShowModalEditParameter,
  selectedParameter,
  trigger,
  setTrigger,
}) => {
  const db = firebase.firestore()
  const deviceId = useParams().deviceId
  const [showModalEditParameterUnit, setShowModalEditParameterUnit] = useState(false)
  const [parameterUnit, setParameterUnit] = useState() // State สำหรับเก็บ parameterUnit
  const [selectedUnit, setSelectedUnit] = useState() // State สำหรับเก็บ parameterUnit
  const [iconUrl, setIconUrl] = useState('') // State สำหรับเก็บ parameterUnit
  const [unitLists, setUnitLists] = useState([])

  const handleRenameParameter = async (row) => {
    setShowModalEditParameter(false)
    Swal.fire({
      title: `Rename '${row?.name}' Parameter`,
      input: 'text',
      inputLabel: 'Enter New Parameter Name',
      inputPlaceholder: 'Enter new parameter name',
      showCancelButton: true,
      confirmButtonText: 'Rename',
      cancelButtonText: 'Cancel',
      inputValidator: (value) => {
        if (!value) {
          return 'You need to write something!'
        }
      },
    }).then(async (result) => {
      if (result.isConfirmed) {
        Swal.fire({
          title: 'Renaming parameter...',
          allowOutsideClick: false,
          onBeforeOpen: () => {
            Swal.showLoading()
          },
        })
        const payload = {
          parameterId: row.parameterId,
          parameterNameNew: result.value,
        }

        try {
          const response = await apiConnect.post('/v1/parameters/rename-parameter', payload)
          Swal.fire({
            icon: 'success',
            title: 'Rename parameter successfully!',
          }).then(() => {
            setTrigger(!trigger)
          })
        } catch (error) {
          console.error('Error fetching data:', error)
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: 'Something went wrong!',
          })
        }
      }
    })
  }

  const handleRenameSettingParameter = async (row) => {
    // Show sweet alrt for get input new device name
    setShowModalEditParameter(false)
    Swal.fire({
      title: `Rename '${row?.name}' Setting Parameter`,
      input: 'text',
      inputLabel: 'Enter New Setting Parameter Name',
      inputPlaceholder: 'Enter new setting parameter name',
      showCancelButton: true,
      confirmButtonText: 'Rename',
      cancelButtonText: 'Cancel',
      inputValidator: (value) => {
        if (!value) {
          return 'You need to write something!'
        }
      },
    }).then(async (result) => {
      if (result.isConfirmed) {
        // Sweet alert loading

        Swal.fire({
          title: 'Renaming setting parameter...',
          allowOutsideClick: false,
          onBeforeOpen: () => {
            Swal.showLoading()
          },
        })
        const payload = {
          settingParameterId: row.parameterId,
          settingParameterNameNew: result.value,
        }

        try {
          const response = await apiConnect.post(
            '/v1/setting-parameters/rename-setting-parameter',
            payload
          )
          Swal.fire({
            icon: 'success',
            title: 'Rename setting parameter successfully!',
          }).then(() => {
            setTrigger(!trigger)
          })
        } catch (error) {
          console.error('Error fetching data:', error)
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: 'Something went wrong!',
          })
        }
      }
    })
  }

  const handleRenameStatusParameter = async (row) => {
    // Show sweet alrt for get input new device name
    setShowModalEditParameter(false)
    Swal.fire({
      title: `Rename '${row?.name}' Status Parameter`,
      input: 'text',
      inputLabel: 'Enter New Status Parameter Name',
      inputPlaceholder: 'Enter new status parameter name',
      showCancelButton: true,
      confirmButtonText: 'Rename',
      cancelButtonText: 'Cancel',
      inputValidator: (value) => {
        if (!value) {
          return 'You need to write something!'
        }
      },
    }).then(async (result) => {
      if (result.isConfirmed) {
        // Sweet alert loading

        Swal.fire({
          title: 'Renaming status parameter...',
          allowOutsideClick: false,
          onBeforeOpen: () => {
            Swal.showLoading()
          },
        })
        const payload = {
          statusParameterId: row.parameterId,
          statusParameterNameNew: result.value,
        }

        try {
          const response = await apiConnect.post(
            '/v1/status-parameters/rename-status-parameter',
            payload
          )
          Swal.fire({
            icon: 'success',
            title: 'Rename status parameter successfully!',
          }).then(() => {
            setTrigger(!trigger)
          })
        } catch (error) {
          console.error('Error fetching data:', error)
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: 'Something went wrong!',
          })
        }
      }
    })
  }

  const handleChangeParameterUnit = async () => {
    setShowModalEditParameter(false)
    setShowModalEditParameterUnit(true)
    try {
      const response = await apiConnect.get(`/v1/units/all-unit/`)

      const sortedUnits = response.data.sort((a, b) => {
        if (a.quantity_name < b.quantity_name) return -1
        if (a.quantity_name > b.quantity_name) return 1
        return 0
      })

      setUnitLists(sortedUnits)
    } catch (error) {
      console.error('Error fetching data:', error)
    }
  }

  const handleParameterUnitChange = (e) => {
    setParameterUnit(e.target.value) // อัปเดตค่า parameterUnit เมื่อเลือก
  }

  const handleSubmitUnitChange = async () => {
    const payload = {
      parameterId: selectedParameter.parameterId,
      iconUrl: selectedParameter.premium
        ? selectedUnit.premium_parameter_icon
        : selectedUnit.parameter_icon,
      unit: selectedUnit.unit_symbol,
      unitId: selectedUnit.unit_id,
    }

    try {
      const response = await apiConnect.post('/v1/parameters/change-unit-parameter', payload)

      Swal.fire({
        icon: 'success',
        title: 'Change parameter unit successfully!',
      }).then(() => {
        setTrigger(!trigger)
        setShowModalEditParameterUnit(false)
      })
    } catch (error) {
      console.error('Error fetching data:', error)
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'Something went wrong!',
      })
    }
  }

  useEffect(() => {
    const selectedUnit = unitLists.find((unit) => unit.unit_id === parameterUnit)
    if (selectedUnit) {
      if (selectedParameter.premium) {
        setIconUrl(selectedUnit.premium_parameter_icon) // อัปเดต URL รูปจาก unitLists
        setSelectedUnit(selectedUnit) // อัปเดตค่า selectedUnit
      } else {
        setIconUrl(selectedUnit.parameter_icon) // อัปเดต URL รูปจาก unitLists
        setSelectedUnit(selectedUnit) // อัปเดตค่า selectedUnit
      }
    } else {
      setIconUrl('') // ตั้งค่าเริ่มต้นหากไม่มีการเลือก
      setSelectedUnit(null) // ตั้งค่าเริ่มต้นหากไม่มีการเลือก
    }
  }, [parameterUnit, unitLists]) // เพิ่ม parameterUnit เป็น dependency

  const handleRemoveParameter = async (selectedParameter) => {
    Swal.fire({
      text: `Do you want to delete the '${selectedParameter.name}' parameter?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, remove it!',
      cancelButtonText: 'No, keep it',
    }).then(async (result) => {
      if (result.isConfirmed) {
        const payload = {
          deviceId: deviceId,
          parameterId: selectedParameter.parameterId,
        }

        try {
          const response = await apiConnect.post('/v1/parameters/remove-parameter', payload)

          const docRef = db.collection('parameters').doc(selectedParameter?.parameterId)
          const docSnap = await docRef.get()

          if (docSnap.exists) {
            await docRef.delete()
            console.log('Document successfully deleted!')
          }

          Swal.fire({
            icon: 'success',
            title: 'Remove parameter successfully!',
          }).then(() => {
            setTrigger(!trigger)
            setShowModalEditParameter(false)
          })
        } catch (error) {
          console.error('Error fetching data:', error)
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: 'Something went wrong!',
          })
        }
      }
    })
  }

  const handleRemoveSettingParameter = async (row) => {
    Swal.fire({
      text: `Do you want to delete the '${row.name}' parameter?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, remove it!',
      cancelButtonText: 'No, keep it',
    }).then(async (result) => {
      if (result.isConfirmed) {
        const payload = {
          deviceId: deviceId,
          parameterId: row.parameterId,
        }

        try {
          const response = await apiConnect.post('/v1/setting-parameters/remove-parameter', payload)
          Swal.fire({
            icon: 'success',
            title: 'Remove parameter successfully!',
          }).then(() => {
            setTrigger(!trigger)
            setShowModalEditParameter(false)
          })
        } catch (error) {
          console.error('Error fetching data:', error)
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: 'Something went wrong!',
          })
        }
      }
    })
  }

  const handleRemoveStatusParameter = async (row) => {
    Swal.fire({
      text: `Do you want to delete the '${row.name}' parameter?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, remove it!',
      cancelButtonText: 'No, keep it',
    }).then(async (result) => {
      if (result.isConfirmed) {
        const payload = {
          deviceId: deviceId,
          parameterId: row.parameterId,
        }

        try {
          const response = await apiConnect.post('/v1/status-parameters/remove-parameter', payload)
          Swal.fire({
            icon: 'success',
            title: 'Remove parameter successfully!',
          }).then(() => {
            setTrigger(!trigger)
            setShowModalEditParameter(false)
          })
        } catch (error) {
          console.error('Error fetching data:', error)
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: 'Something went wrong!',
          })
        }
      }
    })
  }

  return (
    <>
      <Modal
        show={showModalEditParameter}
        onHide={() => setShowModalEditParameter(false)}
        size='md'
      >
        <Modal.Header>
          <Modal.Title>
            <h3 className='fw-600'>Edit `{selectedParameter?.name}` Parameter</h3>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className='p-2 row'>
            <div className='row'>
              <div className='col-12 row mb-6'>
                <label className='col-lg-4 col-form-label fw-bold fs-6'>Parameter ID</label>
                <div className='col-lg-8'>
                  <input
                    type='text'
                    className='form-control form-control-lg form-control-solid'
                    value={selectedParameter?.parameterId}
                    placeholder='Parameter ID'
                    disabled={true}
                  />
                </div>
              </div>
              <div className='col-12 row mb-6'>
                <label className='col-lg-4 col-12 col-form-label  fw-bold fs-6'>
                  Parameter Name
                </label>
                <div className='col-lg-6 col-10'>
                  <input
                    type='text'
                    className='form-control form-control-lg form-control-solid'
                    value={selectedParameter?.name}
                    placeholder='Parameter Name'
                    disabled={true}
                  />
                </div>

                {selectedParameter.type == 'sensor' ? (
                  <div
                    className=' col-lg-1 col-2 btn btn-icon btn-warning'
                    onClick={() => handleRenameParameter(selectedParameter)}
                  >
                    <i className='fas fa-pencil fs-4'></i>
                  </div>
                ) : selectedParameter.type == 'setting_parameter' ? (
                  <div
                    className=' col-lg-1 col-2 btn btn-icon btn-warning'
                    onClick={() => handleRenameParameter(selectedParameter)}
                  >
                    <i className='fas fa-pencil fs-4'></i>
                  </div>
                ) : selectedParameter.type == 'status_parameter' ? (
                  <div
                    className=' col-lg-1 col-2 btn btn-icon btn-warning'
                    onClick={() => handleRenameStatusParameter(selectedParameter)}
                  >
                    <i className='fas fa-pencil fs-4'></i>
                  </div>
                ) : (
                  <></>
                )}
              </div>
              <div className='col-12 row'>
                <label className='col-lg-4 col-12 col-form-label  fw-bold fs-6'>Unit</label>
                <div className='col-lg-6 col-10'>
                  <input
                    type='text'
                    className='form-control form-control-lg form-control-solid'
                    value={selectedParameter?.unit}
                    placeholder='Parameter Unit'
                    disabled={true}
                  />
                </div>

                {selectedParameter.type == 'sensor' ? (
                  <div
                    className=' col-lg-1 col-2 btn btn-icon btn-warning'
                    onClick={() => handleChangeParameterUnit()}
                  >
                    <i className='fas fa-pencil fs-4'></i>
                  </div>
                ) : selectedParameter.type == 'setting_parameter' ? (
                  <></>
                ) : selectedParameter.type == 'status_parameter' ? (
                  <></>
                ) : (
                  <></>
                )}
              </div>
            </div>
            <div className='separator border-3 my-5'></div>
            {/* {selectedParameter.type == 'sensor' ? (
              <div className='col-6'>
                <div
                  className='btn btn-primary w-100'
                  onClick={() => handleRenameParameter(selectedParameter)}
                >
                  <i className='fas fa-pencil fs-3 me-2'></i>
                  Rename
                </div>
              </div>
            ) : selectedParameter.type == 'setting_parameter' ? (
              <div className='col-6'>
                <div
                  className='btn btn-primary w-100'
                  onClick={() => handleRenameSettingParameter(selectedParameter)}
                >
                  <i className='fas fa-pencil fs-3 me-2'></i>
                  Rename
                </div>
              </div>
            ) : selectedParameter.type == 'status_parameter' ? (
              <div className='col-6'>
                <div
                  className='btn btn-primary w-100'
                  onClick={() => handleRenameStatusParameter(selectedParameter)}
                >
                  <i className='fas fa-pencil fs-3 me-2'></i>
                  Rename
                </div>
              </div>
            ) : (
              <></>
            )} */}

            {/* {selectedParameter.type == 'sensor' ? (
              <div className='col-6'>
                <div className='btn btn-primary w-100' onClick={() => handleChangeParameterUnit()}>
                  <i className='fas fa-temperature-half fs-3 me-2'></i>
                  Change Unit
                </div>
              </div>
            ) : selectedParameter.type == 'setting_parameter' ? (
              <></>
            ) : selectedParameter.type == 'status_parameter' ? (
              <></>
            ) : (
              <></>
            )} */}

            <div className='col-12 mt-5'>
              {selectedParameter.type == 'sensor' ? (
                <div
                  className='btn btn-outline btn-outline-dashed btn-outline-danger btn-active-light-danger w-100'
                  onClick={() => handleRemoveParameter(selectedParameter)}
                >
                  <i className='fas fa-trash-can fs-3 me-2'></i>
                  Delete Parameter
                </div>
              ) : selectedParameter.type == 'setting_parameter' ? (
                <div
                  className='btn btn-outline btn-outline-dashed btn-outline-danger btn-active-light-danger w-100'
                  onClick={() => handleRemoveSettingParameter(selectedParameter)}
                >
                  <i className='fas fa-trash-can fs-3 me-2'></i>
                  Delete Parameter
                </div>
              ) : selectedParameter.type == 'status_parameter' ? (
                <div
                  className='btn btn-outline btn-outline-dashed btn-outline-danger btn-active-light-danger w-100'
                  onClick={() => handleRemoveStatusParameter(selectedParameter)}
                >
                  <i className='fas fa-trash-can fs-3 me-2'></i>
                  Delete Parameter
                </div>
              ) : (
                <></>
              )}
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button className='btn btn-secondary' onClick={() => setShowModalEditParameter(false)}>
            Close
          </button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showModalEditParameterUnit}
        onHide={() => setShowModalEditParameterUnit(false)}
        size='md'
      >
        <Modal.Header>
          <Modal.Title>
            <h3 className='fw-600'>Select Parameter Unit for `{selectedParameter?.name}`</h3>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className='p-2'>
            {/* Parameter Unit */}
            <div className='row mb-6'>
              <label className='col-lg-4 col-form-label required fw-bold fs-6'>
                Parameter Unit
              </label>
              <div className='col-lg-8 fv-row'>
                <select
                  className='form-select form-select-solid form-select-lg'
                  onChange={handleParameterUnitChange} // ใช้ handleParameterUnitChange
                  value={parameterUnit} // ผูกกับ State parameterUnit
                >
                  <option value=''>Select Parameter Unit</option>
                  {unitLists.map((unit) => (
                    <option key={unit.unit_id} value={unit.unit_id}>
                      {unit.quantity_name} ({unit.unit_symbol})
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div className='row mb-6'>
              <label className='col-lg-4 col-form-label fw-bold fs-6'>Parameter Icon</label>
              <div className='col-lg-8'>
                {iconUrl ? (
                  <img src={iconUrl} alt='Device Icon' className='w-100px h-100px' />
                ) : (
                  <p>No Icon Available</p>
                )}
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button className='btn btn-primary' onClick={() => handleSubmitUnitChange()}>
            Submit
          </button>
          <button
            className='btn btn-secondary'
            onClick={() => setShowModalEditParameterUnit(false)}
          >
            ปิด
          </button>
        </Modal.Footer>
      </Modal>
    </>
  )
}

export {EditParameterModal}
